import { ViewFactory } from 'wdc-cube-react'
import RegraFormScope from '../regra_form.scopes'
import RegraFormView from './regra_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(RegraFormScope, RegraFormView)
}
